<template>
  <div>
    <h4>{{ $t('construction-residential-du') }}</h4>
    <div class="table-responsive">
      <table class="table table-striped table-bordered">
     <thead>
        <tr>
          <th scope="col" rowspan="2">{{ $t('community') }}</th>
          <th scope="col" colspan="8">{{ $t('month') }}</th>
          <th scope="col" colspan="8">{{ $t('year-to-date') }}</th>
        </tr>
        <tr>
          <th scope="col" colspan="1">{{ $t('single') }}</th>
          <th scope="col" colspan="1">{{ $t('semi') }}</th>
          <th scope="col" colspan="1">{{ $t('row') }}</th>
          <th scope="col" colspan="1">{{ $t('apt') }}</th>
          <th scope="col" colspan="1">{{ $t('total') }}</th>
          <th scope="col" colspan="1">{{ $t('percent-total') }}</th>
          <th scope="col" colspan="1">
            {{ lastYear }}
          </th>
          <th scope="col" colspan="1">{{ $t('change') }}</th>
          <th scope="col" colspan="1">{{ $t('single') }}</th>
          <th scope="col" colspan="1">{{ $t('semi') }}</th>
          <th scope="col" colspan="1">{{ $t('row') }}</th>
          <th scope="col" colspan="1">{{ $t('apt') }}</th>
          <th scope="col" colspan="1">{{ $t('total') }}</th>
          <th scope="col" colspan="1">{{ $t('percent-total') }}</th>
          <th scope="col" colspan="1">
            {{ lastYear }}
          </th>
          <th scope="col" colspan="1">{{ $t('change') }}</th>
        </tr>
     </thead>
     <tbody>
        <tr v-for="(res, i) in response11" :key="i">
          <td scope="row">{{ res.community }}</td>
          <td>{{ res.curr_mon_single_count }}</td>
          <td>{{ res.curr_mon_semi_count }}</td>
          <td>{{ res.curr_mon_row_count }}</td>
          <td>{{ res.curr_mon_apt_count }}</td>
          <td>{{ res.curr_mon_total_count }}</td>
          <td>{{ total[monTotal[res.community]] | percent($LANG) }}</td>
          <td>{{ res.prev_mon_total_count }}</td>
          <td>{{ res.pct_mon_change | percent($LANG) }}</td>
          <td>{{ res.curr_ytd_single_count }}</td>
          <td>{{ res.curr_ytd_semi_count }}</td>
          <td>{{ res.curr_ytd_row_count }}</td>
          <td>{{ res.curr_ytd_apt_count }}</td>
          <td>{{ res.curr_ytd_total_count }}</td>
          <td>{{ total[ytdTotal[res.community]] | percent($LANG) }}</td>
          <td>{{ res.prev_ytd_total_count }}</td>
          <td>{{ res.pct_ytd_change | percent($LANG) }}</td>
        </tr>
        <tr>
          <th scope="row">{{ $t('total') }}</th>
          <td>{{ singleRecord.curr_mon_total }}</td>
          <td>{{ semiRecord.curr_mon_total }}</td>
          <td>{{ rowRecord.curr_mon_total }}</td>
          <td>{{ aptRecord.curr_mon_total }}</td>
          <td>{{ total.curr_mon_total }}</td>
          <td>{{ total.mon_total_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.prev_mon_total }}</td>
          <td>{{ total.mon_total_pct_change | percent($LANG) }}</td>
          <td>{{ singleRecord.single_ytd_total }}</td>
          <td>{{ semiRecord.semi_ytd_total }}</td>
          <td>{{ rowRecord.row_ytd_total }}</td>
          <td>{{ aptRecord.apt_ytd_total }}</td>
          <td>{{ total.curr_ytd_total }}</td>
          <td>{{ total.ytd_total_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.prev_ytd_total }}</td>
          <td>{{ total.ytd_total_pct_change | percent($LANG) }}</td>
        </tr>
        <tr>
          <th scope="row">{{ $t('percent-total') }}</th>
          <td>{{ total.mon_single_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.mon_semi_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.mon_row_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.mon_apt_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.mon_total_pct_of_total | percent($LANG) }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ total.ytd_single_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.ytd_semi_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.ytd_row_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.ytd_apt_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.ytd_total_pct_of_total | percent($LANG) }}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <th scope="row">{{ $t('total') }}, {{ lastYear }}</th>
          <td>{{ singleRecord.prev_mon_total }}</td>
          <td>{{ semiRecord.prev_mon_total }}</td>
          <td>{{ rowRecord.prev_mon_total }}</td>
          <td>{{ aptRecord.prev_mon_total }}</td>
          <td>{{ total.prev_mon_total }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ singleRecord.prev_single_ytd_total }}</td>
          <td>{{ semiRecord.prev_semi_ytd_total }}</td>
          <td>{{ rowRecord.prev_row_ytd_total }}</td>
          <td>{{ aptRecord.prev_apt_ytd_total }}</td>
          <td>{{ total.prev_ytd_total }}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <th scope="row">{{ $t('change') }}</th>
          <td>{{ singleRecord.pct_change | percent($LANG) }}</td>
          <td>{{ semiRecord.pct_change | percent($LANG) }}</td>
          <td>{{ rowRecord.pct_change | percent($LANG) }}</td>
          <td>{{ aptRecord.pct_change | percent($LANG) }}</td>
          <td>{{ total.mon_total_pct_change | percent($LANG) }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ total.prev_ytd_single_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.prev_ytd_semi_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.prev_ytd_row_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.prev_ytd_apt_pct_of_total | percent($LANG) }}</td>
          <td>{{ total.prev_ytd_pct_of_total | percent($LANG) }}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "ConstructionTable",
  data: () => ({
    monTotal: {
      Riel: "mon_riel_pct_of_total",
      "City Centre": "mon_city_center_pct_of_total",
      "Lord Selkirk/West Kildonan": "mon_west_kildonan_pct_of_total",
      "East Kildonan/Transcona": "mon_east_kildonan_pct_of_total",
      Assiniboia: "mon_assiniboia_pct_of_total",
    },
    ytdTotal: {
      Riel: "ytd_riel_pct_of_total",
      "City Centre": "ytd_city_center_pct_of_total",
      "Lord Selkirk/West Kildonan": "ytd_west_kildonan_pct_of_total",
      "East Kildonan/Transcona": "ytd_east_kildonan_pct_of_total",
      Assiniboia: "ytd_assiniboia_pct_of_total",
    },
    response11: [],
    response12: [],
    response13: [],
  }),

  props: {
    curYear: String,
    startDate: String,
    endDate: String,
  },

  created() {
    this.fetchData();
  },

  watch: {
    endDate() {
      this.fetchData();
    }
  },

  methods: {
    fetchData() {
      const startDate = this.startDate;
      const endDate = this.endDate;
      // Construction of Residential Dwelling Units
      // By Community
      const request11 = axios.get(
        `https://data.winnipeg.ca/resource/kdey-aemp.json?$select=community, sum(case(issue_date='${endDate}' and construction_building_type='Single',dwelling_units_created,true,0)) as curr_mon_single_count, sum(case(issue_date='${endDate}' and construction_building_type='Semi',dwelling_units_created,true,0)) as curr_mon_semi_count, sum(case(issue_date='${endDate}' and construction_building_type='Row',dwelling_units_created,true,0)) as curr_mon_row_count, sum(case(issue_date='${endDate}' and construction_building_type='Apartment',dwelling_units_created,true,0)) as curr_mon_apt_count, sum(case(issue_date='${endDate}',dwelling_units_created,true,0)) as curr_mon_total_count, sum(case(issue_date='${startDate}',dwelling_units_created,true,0)) as prev_mon_total_count, case(sum(case(issue_date='${startDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))/sum(case(issue_date='${startDate}',dwelling_units_created,true,0))-1),0)) as pct_mon_change, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and construction_building_type='Single',dwelling_units_created,true,0)) as curr_ytd_single_count, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and construction_building_type='Semi',dwelling_units_created,true,0)) as curr_ytd_semi_count, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and construction_building_type='Row',dwelling_units_created,true,0)) as curr_ytd_row_count, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and construction_building_type='Apartment',dwelling_units_created,true,0)) as curr_ytd_apt_count, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0)) as curr_ytd_total_count, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_created,true,0)) as prev_ytd_total_count, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_created,true,0))-1),0)) as pct_ytd_change&$where=issue_date between date_trunc_y('${endDate}') and '${endDate}' or issue_date between date_trunc_y('${startDate}') and '${startDate}'&$group=community`
      );
      // By Building Type
      const request12 = axios.get(
        `https://data.winnipeg.ca/resource/kdey-aemp.json?$select=construction_building_type, sum(case(issue_date='${endDate}',dwelling_units_created,true,0)) as curr_mon_total, sum(case(issue_date='${startDate}',dwelling_units_created,true,0)) as prev_mon_total, case(sum(case(issue_date='${startDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))/sum(case(issue_date='${startDate}',dwelling_units_created,true,0))-1),0)) as pct_change, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type="Single",dwelling_units_created,true,0)) as single_ytd_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type="Semi",dwelling_units_created,true,0)) as semi_ytd_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type="Row",dwelling_units_created,true,0)) as row_ytd_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type="Apartment",dwelling_units_created,true,0)) as apt_ytd_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type="Single",dwelling_units_created,true,0)) as prev_single_ytd_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type="Semi",dwelling_units_created,true,0)) as prev_semi_ytd_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type="Row",dwelling_units_created,true,0)) as prev_row_ytd_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type="Apartment",dwelling_units_created,true,0)) as prev_apt_ytd_total&$where=(issue_date between date_trunc_y('${endDate}') and '${endDate}' or issue_date between date_trunc_y('${startDate}') and '${startDate}') and construction_building_type in ('Single','Semi','Row','Apartment')&$group=construction_building_type`
      );
      // Percentage of totals
      const request13 = axios.get(
        `https://data.winnipeg.ca/resource/kdey-aemp.json?$select=case(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and community='City Centre',dwelling_units_created,true,0))/sum(case(issue_date='${endDate}',dwelling_units_created,true,0))),0)) as mon_city_center_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and community='Assiniboia',dwelling_units_created,true,0))/sum(case(issue_date='${endDate}',dwelling_units_created,true,0))),0)) as mon_assiniboia_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and community='Lord Selkirk/West Kildonan',dwelling_units_created,true,0))/sum(case(issue_date='${endDate}',dwelling_units_created,true,0))),0)) as mon_west_kildonan_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and community='East Kildonan/Transcona',dwelling_units_created,true,0))/sum(case(issue_date='${endDate}',dwelling_units_created,true,0))),0)) as mon_east_kildonan_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and community='Riel',dwelling_units_created,true,0))/sum(case(issue_date='${endDate}',dwelling_units_created,true,0))),0)) as mon_riel_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and building_type='Single',dwelling_units_created,true,0))/sum(case(issue_date='${endDate}',dwelling_units_created,true,0))),0)) as mon_single_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and building_type='Semi',dwelling_units_created,true,0))/sum(case(issue_date='${endDate}',dwelling_units_created,true,0))),0)) as mon_semi_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and building_type='Row',dwelling_units_created,true,0))/sum(case(issue_date='${endDate}',dwelling_units_created,true,0))),0)) as mon_row_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and building_type='Apartment',dwelling_units_created,true,0))/sum(case(issue_date='${endDate}',dwelling_units_created,true,0))),0)) as mon_apt_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))/sum(case(issue_date='${endDate}',dwelling_units_created,true,0))),0)) as mon_total_pct_of_total, sum(case(issue_date='${endDate}',dwelling_units_created,true,0)) as curr_mon_total, sum(case(issue_date='${startDate}',dwelling_units_created,true,0)) as prev_mon_total, case(sum(case(issue_date='${startDate}',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}',dwelling_units_created,true,0))/sum(case(issue_date='${startDate}',dwelling_units_created,true,0))-1),0)) as mon_total_pct_change, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and community='City Centre',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))),0)) as ytd_city_center_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and community='Assiniboia',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))),0)) as ytd_assiniboia_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and community='Lord Selkirk/West Kildonan',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))),0)) as ytd_west_kildonan_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and community='East Kildonan/Transcona',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))),0)) as ytd_east_kildonan_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and community='Riel',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))),0)) as ytd_riel_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type='Single',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))),0)) as ytd_single_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type='Semi',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))),0)) as ytd_semi_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type='Row',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))),0)) as ytd_row_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type='Apartment',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))),0)) as ytd_apt_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type='Single',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type='Single',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type='Single',dwelling_units_created,true,0))-1),0)) as prev_ytd_single_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type='Semi',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type='Semi',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type='Semi',dwelling_units_created,true,0))-1),0)) as prev_ytd_semi_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type='Row',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type='Row',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type='Row',dwelling_units_created,true,0))-1),0)) as prev_ytd_row_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type='Apartment',dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and building_type='Apartment',dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}') and building_type='Apartment',dwelling_units_created,true,0))-1),0)) as prev_ytd_apt_pct_of_total,case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_created,true,0))-1),0)) as prev_ytd_pct_of_total,case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'), dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))),0)) as ytd_total_pct_of_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0)) as curr_ytd_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_created,true,0)) as prev_ytd_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_created,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_created,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_created,true,0))-1),0)) as ytd_total_pct_change&$where=(issue_date between date_trunc_y('${endDate}') and '${endDate}' or issue_date between date_trunc_y('${startDate}') and '${startDate}') and construction_building_type in ('Single','Semi','Row','Apartment')`);

      const self = this;
      axios
        .all([
          request11,
          request12,
          request13,
        ])
        .then(
          axios.spread(function (
            response11,
            response12,
            response13,
          ) {
            self.response11 = response11.data;
            self.response12 = response12.data;
            self.response13 = response13.data;
          })
        );
    }
  },

  computed: {
    lastYear() {
      return parseInt(this.curYear) - 1;
    },

    defaultSingleRecord() {
      return {
        curr_mon_total: "",
        pct_change: "",
        prev_mon_total: "",
        single_ytd_total: "",
        prev_single_ytd_total: "",
      };
    },

    defaultSemiRecord() {
      return {
        curr_mon_total: "",
        pct_change: "",
        prev_mon_total: "",
        semi_ytd_total: "",
        prev_semi_ytd_total: "",
      };
    },

    defaultRowRecord() {
      return {
        curr_mon_total: "",
        pct_change: "",
        prev_mon_total: "",
        row_ytd_total: "",
        prev_row_ytd_total: "",
      };
    },

    defaultAptRecord() {
      return {
        curr_mon_total: "",
        pct_change: "",
        prev_mon_total: "",
        apt_ytd_total: "",
        prev_apt_ytd_total: "",
      };
    },

    defaultTotal() {
      return {
        curr_mon_total: "",
        curr_ytd_total: "",
        mon_apt_pct_of_total: "",
        mon_assiniboia_pct_of_total: "",
        mon_city_center_pct_of_total: "",
        mon_east_kildonan_pct_of_total: "",
        mon_riel_pct_of_total: "",
        mon_row_pct_of_total: "",
        mon_semi_pct_of_total: "",
        mon_single_pct_of_total: "",
        mon_total_pct_change: "",
        mon_total_pct_of_total: "",
        mon_west_kildonan_pct_of_total: "",
        prev_mon_total: "",
        prev_ytd_total: "",
        ytd_apt_pct_of_total: "",
        ytd_assiniboia_pct_of_total: "",
        ytd_city_center_pct_of_total: "",
        ytd_east_kildonan_pct_of_total: "",
        ytd_riel_pct_of_total: "",
        ytd_row_pct_of_total: "",
        ytd_semi_pct_of_total: "",
        ytd_single_pct_of_total: "",
        ytd_total_pct_change: "",
        ytd_total_pct_of_total: "",
        ytd_west_kildonan_pct_of_total: "",
        prev_ytd_single_pct_of_total: "",
        prev_ytd_semi_pct_of_total: "",
        prev_ytd_row_pct_of_total: "",
        prev_ytd_apt_pct_of_total: "",
        prev_ytd_pct_of_total: "",
      };
    },

    singleRecord() {
      if (this.response12.length === 0) return this.defaultSingleRecord;
      const record = this.response12.find(
        (item) => item.construction_building_type === "Single"
      );
      return record || this.defaultSingleRecord;
    },
    semiRecord() {
      if (this.response12.length === 0) return this.defaultSemiRecord;
      const record = this.response12.find(
        (item) => item.construction_building_type === "Semi"
      );
      return record || this.defaultSemiRecord;
    },
    rowRecord() {
      if (this.response12.length === 0) return this.defaultRowRecord;
      const record = this.response12.find(
        (item) => item.construction_building_type === "Row"
      );
      return record || this.defaultRowRecord;
    },
    aptRecord() {
      if (this.response12.length === 0) return this.defaultAptRecord;
      const record = this.response12.find(
        (item) => item.construction_building_type === "Apartment"
      );
      return record || this.defaultAptRecord;
    },
    total() {
      if (this.response13.length === 0) return this.defaultTotal;
      return this.response13[0];
    },
  },
};
</script>
